/* global globalThis */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PopupTypes } from '../../../components/Popup';
import { T } from '../../../components/Translations';
import { ApiUrl, AppPages, Defines } from '../../../project/Defines';
import { Project } from '../../../project/Project';
import { EVENT_NAME, dispatchCustomEvent, useCustomEvent } from '../../../project/utilities';
import ListView from '../../../Shared/ListView';
import { COLUMN_FORMAT, COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { openPopup } from '../../../store/actions';
import { isDocumentReadOnly, isDocumentReadOnlyForFeesAndSpareParts, skipDocumenConfirmingActions, useConfirmActions } from '../commonFunctions';

import moment from 'moment';



const listUpdateEvent = EVENT_NAME.FEE_LIST_UPDATE;
/**
 * @exports Fees
used in Documents menu and in Service Call tab
 */
function Fees(props) {
    const { dataItem, openPopup, disabled } = props;
    const isServiceCallTabMode = !!dataItem;
    const staticFilter = isServiceCallTabMode ? { call_id: dataItem?.call_id } : { confirmed: false };
    const detailProps = {
        newTitle: 'text.new_fee',
        editTitle: 'text.fee_detail',
        popupType: PopupTypes.FeeDetail,
        windowKey: 'wndFeeDetail',
        isServiceCallTabMode,
        newData: isServiceCallTabMode && { data: { callData: dataItem } }
    };
    const { onConfirm, onReject } = useConfirmActions({ openPopup, type: 'PO', listUpdateEvent });
    const [isMobile, setIsMobile] = useState(globalThis.innerWidth <= 768);

    useCustomEvent(EVENT_NAME.SERVICE_CALL_UPDATED, (event) => {
        if (!isServiceCallTabMode) {
            return;
        }

        const updatedCall = event?.detail?.data;
        const isSameById = updatedCall?.ID && dataItem?.ID && String(updatedCall.ID) === String(dataItem.ID);
        const isSameByCallId = updatedCall?.call_id && dataItem?.call_id && String(updatedCall.call_id) === String(dataItem.call_id);

        if (isSameById || isSameByCallId) {
            dispatchCustomEvent(listUpdateEvent, { silent: true });
        }
    });

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(globalThis.innerWidth <= 768);
        };
        
        globalThis.addEventListener('resize', handleResize);
        return () => globalThis.removeEventListener('resize', handleResize);
    }, []);

    const columns = [
        {
            text: 'text.purchase_order_id',
            noSort: 'true',
            field: 'DocNum',
            fixed: 'left',
            width: 80,
            type: COLUMN_TYPE.TEXT,
        },
        {
            skip: isServiceCallTabMode,
            text: 'text.call_id',
            render: (text, record) => {
                return <wrap>
                    {(record.callData && <Link to={Project.getPageUrl(AppPages.ServiceCallsDetails, record.callData.ID)} style={{ color: "var(--main-color)" }}>
                        <text>{record.SCOrigin}</text>
                    </Link>) || <text>{record.SCOrigin}</text>}
                </wrap>;
            },
            noSort: 'true',
            field: 'SCOrigin',
            width: 100,
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.subcontractor',
            // noSort: 'true',
            field: 'subcontractor_name',
            render: (text, record) => {
                return <wrap>
                    { record.callData && <text>{record.callData.subcontractor_name}</text> }
                </wrap>
            },
            width: 240,
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.appointment_date_at',
            //noSort: 'true',
            field: 'appointment_date_at',
            render: (text, record) => {
                return <wrap>
                    { record.callData && <text>{moment.utc(record.callData?.appointment_date_at).local().format(Defines.Format.MomentDate)}</text> }
                </wrap>
            },
            type: COLUMN_TYPE.TEXT,
            width: 100,
            format: COLUMN_FORMAT.DATE
        },
        {
            text: 'text.date',
            noSort: 'true',
            field: 'DocDate',
            type: COLUMN_TYPE.TEXT,
            width: 100,
            format: COLUMN_FORMAT.DATE
        },
        {
            text: 'text.total',
            noSort: 'true',
            field: 'DocTotal',
            width: 100,
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.status',
            noSort: 'true',
            field: 'DocStatus',
            type: COLUMN_TYPE.TEXT,
            width: 170,
            render: (text, record) => {
                return (
                    <wrap>
                        <group> <text>{text}</text>
                            {record.IsChangeRequested && <badge l_space="" outline=""
                            ><T>text.change_requested</T></badge>}
                        </group>
                    </wrap>
                );
            },
        },
        {
            skip: !isServiceCallTabMode,
            text: 'text.confirmed',
            noSort: 'true',
            field: 'Confirmed',
            width: 100,
            type: COLUMN_TYPE.TEXT,
        },
        {
            skip: disabled,
            type: COLUMN_TYPE.ACTION,
            fixed: 'right',
            width: (isMobile ? "" : 100),
            commands: [
                { command: 'edit', skipCommandForRecord: isDocumentReadOnly },
                { command: 'edit', icon: 'eye', key: 'view', skipCommandForRecord: record => !isDocumentReadOnly(record) },
                { command: 'done', skipCommandForRecord: skipDocumenConfirmingActions, onClick: onConfirm, tooltip: 'text.approve' },
                { command: 'close', skipCommandForRecord: skipDocumenConfirmingActions, onClick: onReject, tooltip: 'text.reject' }
            ]

        }
    ].filter(col => !col.skip);
// debugger;
    const readOnly = isServiceCallTabMode && isDocumentReadOnlyForFeesAndSpareParts({ callData: dataItem });
    const hasValidStatusID = dataItem?.status_id === '-3' || dataItem?.status_id === '1' || dataItem?.status_id === '27';
    
    return (
        <ListView
            {...props}
            // className='scroll_fix visible_buttons'
            className={`scroll_fix ${isMobile ? "visible_buttons" : ""}`}
            columnConfig={columns}
            staticFilter={staticFilter}
            apiUrl={ApiUrl.FeeList}
            noPaging
            keyField="DocNum"
            listUpdateEvent={listUpdateEvent}
            detailProps={detailProps}
            isSimple={isServiceCallTabMode}
            skipEdit={disabled}
            skipNewButton={disabled || !isServiceCallTabMode || readOnly || !hasValidStatusID}
        />
    );
}

Fees.propTypes = {
    dataItem: PropTypes.object,
    openPopup: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default connect(null, dispatch => ({ openPopup: props => dispatch(openPopup(props)) }))(Fees);